import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import "./style.css";
import Header from "../../../Common/header";
import axios from "../../../utils/http";
import { VERIFY_IMEI } from "../../../utils/urls";
import Loader from "../../../Common/Loader";
import { Button } from "@material-ui/core";
import Box from "@mui/material/Box";

export default function ImeiScreenCard() {
  const history = useHistory();
  const historyState: any = history.location.state;
  const application_id: number =
    historyState == undefined
      ? history.push("/dashboard")
      : historyState.application_id;
  const [imei, setIemi] = useState("");
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIemi(e.target.value);
    setError("");
  };

  const handleSubmit = () => {
    if (imei == "") {
      return setError("Please enter valid imei number");
    }

    setLoader(true);
    axios
      .post(VERIFY_IMEI, {
        cd_application_id: application_id,
        imei_number: imei,
      })
      .then((res) => {
        setLoader(false);
        if (res.data.results) {
          history.push("/downpayment", { application_id, imei });
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(
          error.response.data.errors?.detail || error.response.data.errors
        );
        setError(
          error.response.data.errors?.detail || error.response.data.errors
        );
      });
    // history.push('/downpayment')
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <div className="imeiCard loginPage">
      <div>
        <Header pageName="Imei Number" />
      </div>
      <div id="main">
        <div id="card">
          <Box sx={{ mb: 4, mt: 2 }}>
            {error ? (
              <h6 style={{ color: "red", textAlign: "center" }}>{error}</h6>
            ) : (
              ""
            )}
            <Box sx={{ mb: 1 }}>
              <label>Enter IMEI number</label>
            </Box>

            <TextField
              id="outlined-basic"
              className="input"
              name="userId"
              onChange={handleChange}
              fullWidth
            />
          </Box>

          <Box id="buttonId" sx={{ mb: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              className="redButton"
              type="submit"
              onClick={handleSubmit}
            >
              Proceed
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}
